import React from 'react';
import { withTranslate } from 'react-redux-multilingual';

const ChangeDir = props => {
	const {
		value,
		translate
	} = props;

	const content = value
		? (
			<span className="sr-only">
				{value > 0 ? translate('up') : translate('down')}
				&nbsp;
			</span>
		) : null;

	return (content);
};

export default withTranslate(ChangeDir);
